export default function formatLineBreaks(value) {
  if (value) return value.replace(/\n/g, '<br>');
  return value;
}
